/**
 * Blueprint for the badge entity.
 */
export class Badge {
  public text: string;
  public badgeValue: string | number;

  constructor(text: string, badgeValue: string | number) {
    this.text = text;
    this.badgeValue = badgeValue;
  }
}
